import { render, staticRenderFns } from "./layout-info-content-window-delivery.vue?vue&type=template&id=c1ce926e&scoped=true&"
import script from "./layout-info-content-window-delivery.vue?vue&type=script&lang=js&"
export * from "./layout-info-content-window-delivery.vue?vue&type=script&lang=js&"
import style0 from "./layout-info-content-window-delivery.vue?vue&type=style&index=0&id=c1ce926e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ce926e",
  null
  
)

export default component.exports